import { render, staticRenderFns } from "./collectProject.vue?vue&type=template&id=763a3dba&scoped=true"
import script from "./collectProject.vue?vue&type=script&lang=js"
export * from "./collectProject.vue?vue&type=script&lang=js"
import style0 from "./collectProject.vue?vue&type=style&index=0&id=763a3dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763a3dba",
  null
  
)

export default component.exports